import { render } from "./ZapiOriginSelector.vue?vue&type=template&id=24ac4e0a&scoped=true"
import script from "./ZapiOriginSelector.vue?vue&type=script&lang=js"
export * from "./ZapiOriginSelector.vue?vue&type=script&lang=js"

import "./ZapiOriginSelector.vue?vue&type=style&index=0&id=24ac4e0a&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ac4e0a"]])

export default __exports__